import { QueryKey } from 'constants/reactQuery';

export const accountsQueryKey = {
  user: [QueryKey.User] as const,
  marketingAgreement: [QueryKey.User, QueryKey.UserMarketingAgreement] as const,
  reportProfile: (id: number) => [QueryKey.Profile, id, QueryKey.Report] as const,
  signIn: [QueryKey.Sign, 'signIn'] as const,
  signUp: [QueryKey.Sign, 'signUp'] as const,
};
